import { QuestionnaireTimestamp } from "pokal_api"

export interface CounterMeasureQuestion {
    content: string
    onYes: CounterMeasureQuestion | boolean
    onNo: CounterMeasureQuestion | boolean
    customYes?: string
}

const QUESTION_BEFORE_SELECTION: CounterMeasureQuestion = {
    content:
        "Planen Sie, eine Maßnahme zu ergreifen?",
    onYes: true,
    onNo: false
}

const QUESTION_3: CounterMeasureQuestion = {
    content: "Planen Sie, eine andere Maßnahme zu ergreifen?",
    onYes: true,
    onNo: false
}

const QUESTION_2: CounterMeasureQuestion = {
    content:
        "Wurde die geplante Maßnahme erfolgreich durchgeführt?",
    onNo: QUESTION_3,
    onYes: false,
    customYes: "Zu diesem Zeitpunkt noch kein Urteil möglich"
}

const QUESTION_1: CounterMeasureQuestion = {
    content:
        "Wurde für diesen Arzneistoff zu einem vorherigen Zeitpunkt eine Maßnahme geplant?",
    onNo: QUESTION_BEFORE_SELECTION,
    onYes: QUESTION_2
}

const CounterMeasureQuestionnaire = (
    timestamp: QuestionnaireTimestamp
): CounterMeasureQuestion[] =>
    timestamp === QuestionnaireTimestamp.T0
        ? [QUESTION_BEFORE_SELECTION]
        : [QUESTION_1]

export default CounterMeasureQuestionnaire